/**
* Author: Student Agency edited by Diego La Monica http://diegolamonica.info
* Detailed description of this work is available on http://diegolamonica.info/improving-jquery-infinite-carousel-part-1
* Based on original script described on http://jqueryfordesigners.com/demo/infinite-carousel.html
*/
(function ($) {
  'use strict';
  $.fn.infiniteCarousel = InfiniteCarousel;
  function InfiniteCarousel () {

    var win = $(window),
      ontouch = require('./swipedetect'),
      wrapper = $('> .slider-wrapper', this).css('overflow', 'hidden'),
      slider = wrapper.find('> ul'),
      items = slider.find('> li'),
      singleWidth = items.filter(':first').outerWidth(true),
      currentPage = 1,
      delay = 8000,
      autoplay = 0;

    initialize();
    win.resize(initialize);

    // buttons
    $('.back', this).click(goBack);
    $('.forward', this).click(goForward);

    // keyboard
    $(document).keydown(function (e) {
      if (e.keyCode === 37) goBack();
      else if (e.keyCode === 39) goForward();
    });

    // touch
    /*
    zakomentovano, jinak nefunguje posouvani slideru na telefonu
    ontouch(this[0], function(evt, dir, phase){
      if (phase === 'end' && dir === 'left') goForward();
      if (phase === 'end' && dir === 'right') goBack();
    });
    */

    function initialize () {
      stopPlay();
      $('.cloned', wrapper).remove();
      var items = getItems(),
        sliderLeftOffset = ((win.width() - $('.wrapper').width()) / 2);
        items.filter(':first').before(clone(items.slice(-3))); // nastavime 3 kvuli mobilu, jinka je videt bile misto kdyz nejsou naklonovane 3 itemy
        items.filter(':last').after(clone(items.slice(0, 3))); // nastavime 3 kvuli mobilu, jinka je videt bile misto kdyz nejsou naklonovane 3 itemy
      //items.filter(':first').before(clone(items.slice(-getPageSize())));
      //items.filter(':last').after(clone(items.slice(0, getPageSize())));
      //wrapper.scrollLeft(singleWidth * getPageSize());
      wrapper.scrollLeft(singleWidth * 3);
      slider.css({
        left: sliderLeftOffset,
        width: getItems().length * singleWidth + singleWidth * 3 // musime pricist jeste nejakou sirku navic, jinak scrollLeft nefunguje spravne a slider se zasekava
      });
      //createPageNav();
      autoPlay();
    }

    function clone (items) {
      items = items.clone().addClass('cloned');
      items.find('iframe').attr('id', '');
      return items;
    }

    function goToPage (page) {

      var direction = page < currentPage ? -1 : 1,
        pageSize = getPageSize(),
        step = Math.abs(currentPage - page),
        scrollLeft = direction * singleWidth * pageSize * step;

      stopPlay();
      wrapper.filter(':not(:animated)').animate({
        scrollLeft: '+=' + scrollLeft
      }, 500).promise().done(animationComplete);
      autoPlay();

      function animationComplete () {
        //console.log('hooked');
        if (page === 0) {
          let correction;
          if (pageSize === 1)
            correction = singleWidth * 2;
          else if (pageSize === 2)
            correction = singleWidth;
          else
            correction = 0;

          wrapper.scrollLeft(singleWidth * pageSize * getPageCount() + correction);
          //wrapper.scrollLeft(singleWidth * pageSize * getPageCount());
          //wrapper.scrollLeft(singleWidth * 3 * getPageCount());
          page = getPageCount();
        } else if (page > getPageCount()) {
          //wrapper.scrollLeft(singleWidth * getPageSize());
          wrapper.scrollLeft(singleWidth * 3);
          page = 1;
        }
        currentPage = page;
        setActivePage(currentPage);
        //console.log(currentPage);
      }

    }

    function createPageNav () {
      var pageNav = $('#pager'),
        i = 0;
      pageNav.empty();
      for (i; i < getPageCount(); i++) {
        $('<span class="pager"/>').click(pagerClickHandler).attr('data-page', i + 1).appendTo(pageNav);
      }


      function pagerClickHandler () {
        /* jshint validthis: true */
        return goToPage($(this).attr('data-page'));
      }
    }

    function setActivePage (page) {
      $('.pager').removeClass('activePage');
      $('.pager[data-page=' + page + ']').addClass('activePage');
    }

    function getItems () {
      return slider.find('> li');
    }

    function getPageSize () {
      var currentPageSie = Math.floor($('.wrapper').width() / singleWidth);
      if (currentPageSie == 0)
        return 1;
      else
        return currentPageSie;
    }

    function getPageCount () {
      return Math.ceil(getItems().not('.cloned').length / getPageSize());
    }

    function autoPlay () {
      autoplay = setInterval(function () {
        goToPage(currentPage + 1);
      }, delay);
    }

    function stopPlay () {
      clearInterval(autoplay);
    }

    function goBack () {
      return goToPage(currentPage - 1);
    }

    function goForward () {
      return goToPage(currentPage + 1);
    }
  }
})(jQuery);